import messageReducer from './messageReducer';

export default messageReducer;
